<script>
import SubHeader from '@components/sub-header'
import { widgetActions } from '@state/helpers'
import { mapGetters } from 'vuex'
import InfoBox from '@components/info-box'

export default {
  name: 'ScreenSatisfaction',
  components: {
    SubHeader,
    InfoBox,
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      agree: null,
    }
  },
  computed: {
    infoBoxData () {
      return {
        data: {
          icon: 'clock',
          text: this.$t('COMPONENTS.INFO_BOX.COPY'),
        },
        styles: {
          color: '#f8d877',
        },
      }
    },
    widgetContent () {
      return {
        title: this.$t('WIDGETS.SCREEN_SATISFACTION.TITLE'),
        mandatoryMsj: this.$t('WIDGETS.SCREEN_SATISFACTION.MANDATORY_MSJ').toUpperCase()
      }
    },
    ...mapGetters('widgets', ['isFormWidgetRendered']),
  },
  watch: {
    agree () {
      // emit data change to be listen in the store
      this.commitWidgetChanges({
        widgetName: 'ScreenSatisfaction',
        data: {
          notSatisfied: this.agree,
        },
      })
    },
  },
  methods: {
    ...widgetActions,
    getImgUrl (name) {
      var image = require.context('@assets/images/', false, /\.png$/)
      return image('./' + name + '.png')
    },
    setOption () {
      this.agree = false
      this.$scrollTo(`#${this.$options.name}`, 1000)
      this.$emit('onDataChange', false) // emit event to form widget
      // this.showForm = !childData
    },
    imageFallBack (name) {
      const index = this.componentData.buttons.findIndex(
        b => b.imgFallback === name
      )
      if (index !== -1) {
        this.componentData.buttons[index].img = this.getImgUrl(name)
        this.$forceUpdate()
      }
    },
  },
}
</script>

<template>
  <div>
    <button
      :class="$style.container"
      @click="setOption()"
    >
      <div>
        <SubHeader
          :class="$style.container__header"
          :text="widgetContent.title"
        />
      </div>
      <div :class="$style.container__buttons">
        <span :class="$style.pill">
          {{ widgetContent.mandatoryMsj }}
        </span>
        <img
          alt="check"
          src="@assets/images/expand_more.svg"
        >
      </div>
    </button>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  padding: 2rem 0 2rem 0;
  margin: $size-spacing-medium 0;
  background-color: $background-container;
  width: 100%;

  div:first-child {
    flex-grow: 1;
  }

  &__header {
    margin: 0 16px;
    font-size: 1.45rem;
  }

  &__buttons {
    display: flex;
    flex-direction: row;
    margin-top: 4px;

    .pill {
      height: 21px;
      font-size: 0.7rem;
      font-weight: bold;
      color: $white;
      background-color: $red-primary;
      border: solid $red-primary;
      border-radius: 15px;
    }

    img {
      padding: 0 16px;
    }
  }
}

button {
  outline: none;
}
.infoBox {
  // margin-bottom: 1rem;
  margin: 1rem auto;
}
</style>
